import { z } from "zod";
export const PipelineExporterQuery = z.object({
    exporterId: z.string().optional(),
});
